import { TriggerCreate } from "@dots-projects/types";
import { v4 as uuidv4 } from "uuid";
import gif from "./rsvp.gif";

export const eventRSVP = (
  workspace: string
): {
  trigger: TriggerCreate;
  gif: any;
  title: string;
  description: string;
} => {
  return {
    title: "Event RSVP",
    description:
      "<p>Let the whole server know about your upcoming events! In this template Dots will add a button that allows users to confirm their attendance and optionally enter their email address to be added to a guest list, send an invitation to their calendar or whatever you can think of!</p>",
    gif,
    trigger: {
      name: "Event RSVP",
      type: "button_click",
      platform: "discord",
      communityId: localStorage.getItem("guild-id") || "",
      authorUserId: localStorage.getItem("discord-id") || "",
      workspace,
      isDraft: true,
      configs: {
        messages: [
          {
            id: uuidv4(),
            buttonIds: [uuidv4()],
          },
        ],
        responseOnError: "Something went wrong, please try again!",
        $$editorButtonClickContent: {
          message:
            "We will be having **<event name>** next week! We look forward to chatting with those that can join us on **<day>** at **<time>**!",
          channelId: "$channelId",
          buttonText: "RSVP",
          buttonEmoji: "🗓️",
          htmlMessage:
            "<p>We will be having <strong>&lt;event name&gt;</strong> next week! We look forward to chatting with those that can join us on <strong>&lt;day&gt;</strong> at <strong>&lt;time&gt;</strong>!</p>",
        },
      },
      steps: [
        {
          id: "open_modal-0-jYDKYH",
          type: "open_modal",
          configs: {
            title: "Calendar invite",
            fields: [
              {
                id: "field",
                type: "open_modal",
                label: "Please share email if you would like a calendar invite",
                style: "short",
              },
            ],
          },
          isEntry: false,
          isGoal: false,
          name: "Show a modal",
          transitions: [
            {
              targetStepId: "send_message-0-zMsg-n",
              when: {
                userResponse: {
                  type: "modal-submit",
                  userId: "{{user.id}}",
                  modalId: "{{open_modal-0-jYDKYH.modalId}}",
                },
              },
            },
          ],
        },
        {
          id: "send_message-0-7m7hPp",
          type: "send_message",
          configs: {
            message:
              "We'll miss you, but don't worry we look forward to seeing you at our next event.\n  \nThanks for your reply!",
            channelId: "{{interaction.channelId}}",
            ephemeral: true,
            delaySeconds: 0,
            removeUrlEmbeds: false,
            $$editorHtmlMessage:
              "<p>We'll miss you, but don't worry we look forward to seeing you at our next event.</p><p><br></p><p>Thanks for your reply!</p>",
          },
          isEntry: false,
          isGoal: false,
          name: "Send a message",
          transitions: [
            { targetStepId: "$$step-placeholder-n7K4TMtransition" },
          ],
        },
        {
          id: "send_message-0-zMsg-n",
          type: "send_message",
          configs: {
            message:
              "We will send you the invitation to your calendar as soon as possible.\n  \nThanks for your reply!",
            channelId: "{{interaction.channelId}}",
            ephemeral: true,
            delaySeconds: 0,
            removeUrlEmbeds: false,
            $$editorHtmlMessage:
              "<p>We will send you the invitation to your calendar as soon as possible.</p><p><br></p><p>Thanks for your reply!</p>",
          },
          isEntry: false,
          isGoal: false,
          name: "Send a message",
          transitions: [
            { targetStepId: "$$step-placeholder-n7K4TMtransition" },
          ],
        },
        {
          id: "$$step-placeholder-n7K4TMtransition",
          type: "idle",
          isEntry: false,
          isGoal: false,
          transitions: [],
        },
        {
          id: "send_survey-0-x4eDXB",
          type: "send_survey",
          configs: {
            type: "buttons",
            message: "Would you be attending?",
            options: [
              {
                id: "africa-send_survey-0-x4eDXB",
                emoji: "✅",
                label: "Yes!",
                skipDefer: true,
              },
              {
                id: "na-send_survey-0-x4eDXB",
                emoji: "❌",
                label: "No",
                skipDefer: true,
              },
              {
                id: "KC3sNr-option",
                emoji: "🤔",
                label: "Maybe",
                skipDefer: true,
              },
            ],
            feedback: { disable: true },
            channelId: "{{interaction.channelId}}",
            ephemeral: true,
            delaySeconds: 0,
            $$editorHtmlMessage: "<p>Would you be attending?</p>",
            sendBrandingIfNotPremium: true,
          },
          isEntry: true,
          isGoal: false,
          name: "Send a survey (single selection)",
          transitions: [
            {
              targetStepId: "open_modal-0-jYDKYH",
              when: {
                userResponse: {
                  type: "button",
                  userId: "{{user.id}}",
                  buttonId: "africa-send_survey-0-x4eDXB",
                  messageId: "{{send_survey-0-x4eDXB.messageId}}",
                },
              },
            },
            {
              targetStepId: "send_message-0-7m7hPp",
              when: {
                userResponse: {
                  type: "button",
                  userId: "{{user.id}}",
                  buttonId: "na-send_survey-0-x4eDXB",
                  messageId: "{{send_survey-0-x4eDXB.messageId}}",
                },
              },
            },
            {
              targetStepId: "open_modal-0-jYDKYH",
              when: {
                userResponse: {
                  type: "button",
                  userId: "{{user.id}}",
                  buttonId: "KC3sNr-option",
                  messageId: "{{send_survey-0-x4eDXB.messageId}}",
                },
              },
            },
          ],
        },
      ],
    },
  };
};
